<mat-expansion-panel class="pretty-easy-accordion-link-group__panel"
                     (opened)="unfoldSidebar()">

    <mat-expansion-panel-header class="pretty-easy-accordion-link-group__header"
                                [matTooltip]="isSidebarFolded ? (label() | translate) : null"
                                [matTooltipPosition]="isSidebarFolded ? 'right' : null">
        <mat-panel-title class="pretty-easy-accordion-link-group__title">
            @if (icon()) {
                <mat-icon class="pretty-easy-accordion-link-group__icon"
                          [svgIcon]="icon()">
                </mat-icon>
            }
            <div class="pretty-easy-accordion-link-group__label"
                 [id]="label()">
                {{ label() | translate }}
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>

    <ul class="pretty-easy-accordion-link-group__list"
        [attr.aria-labelledby]="label()">
        @for (data of links(); track data.label) {
            <li class="pretty-easy-accordion-link-group__list-item">
                @if (data.type === 'link' || data.type === 'actionLink') {
                    <app-pretty-easy-link [linkData]="data"
                                          [isSidebarFolded]="isSidebarFolded">
                    </app-pretty-easy-link>
                } @else if (data.type === 'linkGroup') {
                    <app-pretty-easy-link-group [slot]="data"
                                                [isSidebarFolded]="isSidebarFolded">
                    </app-pretty-easy-link-group>
                } @else if (data.type === 'accordionLinkGroup' ) {
                    <app-pretty-easy-accordion-link-group [slot]="data"
                                                          [isSidebarFolded]="isSidebarFolded">
                    </app-pretty-easy-accordion-link-group>
                } @else if (data.type === 'imageLink') {
                    <app-pretty-easy-image-link [linkData]="data"
                                                [isSidebarFolded]="isSidebarFolded">
                    </app-pretty-easy-image-link>
                }
            </li>
        }
    </ul>

</mat-expansion-panel>